<div class="emds icons-container" id="{{Id}}">
  <ng-container *ngFor="let action of columnInfoDto.ActionIcons;">
    <a role="button" title="{{action.MatIcon}}" (click)="action.OnActionCallback(dataItem)">
      <mat-icon class="material-icons" [ngStyle]="action.Format?.NgStyleProperties(dataItem)">{{action.MatIcon}}</mat-icon></a>
  </ng-container>
</div>
